<template>
  <div class="air-container">
    <div class="returnScence" @click="returnScence"></div>
    <div class="air-control">
      <air-num :totalCount="totalCount" :areaName="areaName"></air-num>
      <div class="regular">
        <regular-num
          :waterConditioner="waterConditioner"
          :areaName="areaName"
        ></regular-num>
      </div>
      <div class="regular">
        <vrv-air
          :vrvConditioner="vrvConditioner"
          :areaName="areaName"
        ></vrv-air>
      </div>
    </div>
    <div class="left-content" v-if="isShowDialog">
      <!-- <custom-plane>
        <div class="plane-left">
          <div class="line-item" v-for="item in dialogArray">
            <div class="item-text">{{ item.name }}</div>
            <div class="item-text">{{ getItemValue(item.value) }}</div>
          </div>
        </div>
      </custom-plane> -->
      <pannel-box :headerName="'空调'" :headerData="airInfo">
        <div class="detail-box">
          <div
            class="contentList"
            v-for="(item, key, index) in monitorList"
            :key="index"
          >
            <div class="text">{{ key }}</div>
            <div class="value" :class="item.alarm == '0' ? '' : 'error-color'">
              {{ showItem(item.value)
              }}<span class="detail-unit-data">{{ showUnit(item.value) }}</span>
            </div>
          </div>
        </div>
        <div class="time-type-select" v-if="showHistory">
          <div
            class="time-type-item"
            :id="timeValue == 'day' ? 'active' : ''"
            @click="changeDay('day')"
          >
            时
          </div>
          <div
            class="time-type-item"
            :id="timeValue == 'month' ? 'active' : ''"
            @click="changeDay('month')"
          >
            日
          </div>
          <div
            class="time-type-item"
            :id="timeValue == 'year' ? 'active' : ''"
            @click="changeDay('year')"
          >
            月
          </div>
        </div>
        <div class="bot-content" v-if="showHistory">
          <custom-charts
          v-if="showHistory"
            :dataList="dataList"
            :timer="timeValue"
          ></custom-charts>
        </div>
      </pannel-box>
    </div>
  </div>
</template>
<script>
import bus from "@/components/three-scene/Bus.js";
import airNum from "./components/air-num.vue";
import RegularNum from "./components/regular-num.vue";
import VrvAir from "./components/vrv-air.vue";
import { getAirData, getEqpInfo } from "@/api/index.js";
export default {
  components: { airNum, RegularNum, VrvAir },
  data() {
    return {
      timeValue: "day",
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
      dataList: {
        x: [],
        y: [],
      },
      historical: {},
      totalCount: [],
      waterConditioner: [],
      vrvConditioner: [],
      areaName: "总",
      isShowBtn: false,
      isShowDialog: false,
      airInfo: {},
      dialogData: {},
      monitorList: {},
      timer: null,
    };
  },
  created() {
    this.getAirData();
    this.getLoadData();
    this.timer = setInterval(() => {
      this.getAirData();
      // this.loadData(10, 13);
    }, 30*60*1000);
  },
  computed:{
    showHistory() {
      if (this.historical) {
        return Object.keys(this.historical).length != 0;
      } else {
        return false;
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    historical() {
      this.getLoadData();
    },
  },
  mounted() {
    this.$store.state.threeEvent.intoAirCon = true;
    bus.emit("openFloorLabel", true);
    bus.emit("showFloorPoint", "水空调", true);
    bus.on("setName", this.setBuildName);
    bus.on("dialogNumber", this.showDialog);
  },
  methods: {
    showItem(val) {
      if (val.includes(".")) {
        return val.split(".")[0] + "." + val.split(".")[1].slice(0, 2);
      } else if (val == "暂无数据") {
        return "-";
      } else {
        return val;
      }
    },
    showUnit(val) {
      if (val.includes(".")) {
        return val.split(".")[1].slice(2);
      }
    },
    loadData(first, end) {
      this.dataList = { x: [], y: [] };
      this.historical?.[this.timeValue]?.["用电量"].map((item, index) => {
        let [res] = Object.entries(item);
        this.dataList.x.push(res[0].slice(first, end));
        this.dataList.y.push(res[1]);
      });
    },
    changeDay(value) {
      this.timeValue = value;
      this.getLoadData();
    },
    getLoadData() {
      if (this.timeValue == "day") {
        this.loadData(10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(8, 11);
      } else {
        this.loadData(5, 8);
      }
    },
    async showDialog(eqpCode) {
      if (eqpCode.includes("VRV")) {
        let newEqpCode = eqpCode.slice(3, -2).replace("XF", "KT");
        let rand = Math.floor(Math.random() * 900) + 100;
        let rand1 = Math.floor(Math.random() * 90) + 10;
        let res = {
          baseData: {
            state: "正常",
            id: 5559,
            businessId: 4183261069180928000,
            eqpCode: newEqpCode,
            serialNumber: null,
            eqpName: `VRV空调${rand}`,
            installPos: null,
            upkeepMan: null,
            upkeepUnit: null,
            eqpFactory: "VRV空调",
            eqpModel: "",
            eqpInstallDate: null,
            eqpMfgDate: null,
            eqpUpkeepTel: null,
            eqpUpkeepEndTime: null,
            monitorURL: null,
            actionTime: "无安装日期",
            eqpTypeId: 14,
            status: 1,
            modelSeriesId: 38,
            modelSeries: "VRV空调",
            percent: "100.00%",
            usedTime: "43天7小时17分钟",
            faultTime: "0分钟",
            faultCount: 0,
            createTime: "2022-08-09 14:26:01",
            用电量: `${rand1}.${rand1}kWh`,
          },
          collectionValue: {
            eqpId: null,
            eqpName: `VRV空调${rand}`,
            eqpCode: newEqpCode,
            status: null,
            levelUpperLimit: null,
            data: { 用电量: `${rand1}.${rand1}kWh` },
          },
        };
        // VRV
        this.airInfo = res.baseData;
        this.dialogData = res.baseData;
        this.historical = res.historical;
        this.isShowDialog = true;
        return;
      }
      let { data: res } = await getEqpInfo({ eqpCode });
      // 空调数据
      this.airInfo = res.baseData;
      this.dialogData = res.baseData;
      this.monitorList = res.collectionValue?.data;
      this.historical = res.historical;
      this.isShowDialog = true;
    },
    // getItemValue(val) {
    //   if (val == "用电量") {
    //     return this.dialogData?.collectionValue?.data?.用电量 || "-";
    //   }
    //   if (this.dialogData?.baseData[val]) {
    //     if (val == "status") {
    //       return this.dialogData?.baseData[val] == 1 ? "正常" : "离线";
    //     }
    //     return this.dialogData?.baseData[val];
    //   } else if (this.dialogData?.baseData[val] === "0") {
    //     return "0";
    //   } else {
    //     return "-";
    //   }
    // },
    returnScence() {
      bus.emit("back");
      this.isShowBtn = false;
      this.areaName = "总";
      this.isShowDialog = false;
    },
    setBuildName(name) {
      this.areaName = name;
      this.isShowBtn = true;
    },
    async getAirData() {
      let { data: res } = await getAirData();
      this.totalCount = res.totalCount;
      this.waterConditioner = res.waterConditioner;
      this.vrvConditioner = res.vrv;
    },
  },
};
</script>
<style lang="scss" scoped>
.air-container {
  .returnScence {
    position: absolute;
    width: 144px;
    height: 56px;
    left: 536px;
    top: 135px;
    cursor: pointer;
    background-image: url("../../../../../../assets/pagesImg/returnBtn-normal.png");

    &:hover {
      background-image: url("../../../../../../assets/pagesImg/returnBtn-active.png");
    }
  }
}
.time-type-select {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .time-type-item {
    margin-right: 7px;
    width: 40px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .time-type-item:last-child {
    margin-right: 0;
  }
  #active {
    background: rgba(175, 175, 175, 0.2);
  }
}
.bot-content {
  margin-top: 15px;
  width: 341px;
  height: 140px;
}
.left-content {
  position: absolute;
  right: 43px;
  top: 135px;
  width: 416px;

  .plane-left {
    width: 100%;
    height: 100%;
    padding: 20px;
    padding-left: 34px;

    .line-item {
      width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-between;
      color: #ffffff;
      font-weight: 500;
      font-size: 18px;
      line-height: 29px;

      &:not(:first-child) {
        margin-top: 20px;
      }
    }
  }
}

.air-control {
  position: absolute;
  left: 107px;
  top: 135px;
  width: 416px;

  .regular {
    margin-top: 20px;
  }
}
</style>
